var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.806452 4.193548h17.078961l-2.829195-2.8154855c-.315686-.3141937-.316895-.8247988-.002702-1.1404845.314194-.315726.82484-.3168953 1.140525-.0027419l4.213874 4.1935507c.000282.000242.000483.0005242.000725.0007662.31488.3141937.315888.826452.000081 1.1416941-.000282.000242-.000484.0005242-.000726.0007662L16.194122 9.765164c-.315646.3141131-.826291.3130244-1.140525-.0027419-.314194-.3156857-.312984-.8262908.002702-1.1404845l2.829114-2.8154855H.806452C.361048 5.8064521 0 5.4454035 0 5c0-.4454034.361048-.806452.806452-.806452z","fill":"#FFEDBD","fillRule":"nonzero"}));
}

Arrow.defaultProps = {"viewBox":"0 0 21 10"};

module.exports = Arrow;

Arrow.default = Arrow;
